import BetCard from "../BetCard/BetCard";
import GameActionButton from "../GameActionButton/GameActionButton";
import PregameStatLine from "./PreGameStatLine";
import type { Game } from "../types";
import styles from "../nflMatchupCard.module.scss";

interface PreGameExpansionContentProps {
  game: Game;
}

const PreGameExpansionContent = ({ game }: PreGameExpansionContentProps) => {
  const homeTeam = game.homeTeam ?? {};
  const awayTeam = game.awayTeam ?? {};

  return (
    <div className={styles.expansionContent}>
      <GameActionButton game={game} />
      <div className={styles.expansionCard}>
        <div className={styles.pregameStats}>
          <PregameStatLine
            awayStat={awayTeam?.nfOffenseRank ?? 0}
            homeStat={homeTeam?.nfOffenseRank ?? 0}
            awayRank={awayTeam?.nfOffenseRank ?? 0}
            homeRank={homeTeam?.nfOffenseRank ?? 0}
            statName="Offensive Rank"
            awayColor={awayTeam?.primaryColor}
            homeColor={homeTeam?.primaryColor}
            isRank
          />
          <PregameStatLine
            awayStat={awayTeam?.nfDefenseRank ?? 0}
            homeStat={homeTeam?.nfDefenseRank ?? 0}
            awayRank={awayTeam?.nfDefenseRank ?? 0}
            homeRank={homeTeam?.nfDefenseRank ?? 0}
            statName="Defensive Rank"
            awayColor={awayTeam?.primaryColor}
            homeColor={homeTeam?.primaryColor}
            isRank
          />
          <PregameStatLine
            awayStat={awayTeam?.averagePassingYardsPerGame ?? 0}
            homeStat={homeTeam?.averagePassingYardsPerGame ?? 0}
            awayRank={awayTeam?.passingYPGRank ?? 0}
            homeRank={homeTeam?.passingYPGRank ?? 0}
            statName="Passing YPG"
            awayColor={awayTeam?.primaryColor}
            homeColor={homeTeam?.primaryColor}
          />
          <PregameStatLine
            awayStat={awayTeam?.averageRushingYardsPerGame ?? 0}
            homeStat={homeTeam?.averageRushingYardsPerGame ?? 0}
            awayRank={awayTeam?.rushingYPGRank ?? 0}
            homeRank={homeTeam?.rushingYPGRank ?? 0}
            statName="Rushing YPG"
            awayColor={awayTeam?.primaryColor}
            homeColor={homeTeam?.primaryColor}
          />
        </div>
        <div className={styles.marketsContainer}>
          <h3>Head to Head Markets</h3>
          <div className={styles.markets}>
            <BetCard odds={game?.odds?.away} team={awayTeam} />
            <p>@</p>
            <BetCard odds={game?.odds?.home} team={homeTeam} isRightSide />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreGameExpansionContent;
